/**
 * Converts standard decimal currency amount to smallest unit
 * e.g. 17.36 USD -> 1736 (cents)
 */
const decimalCurrencyToSmallestUnit = (amount: number): number =>
  isNaN(amount) ? 0 : Number((amount * 100).toFixed(0));

export default decimalCurrencyToSmallestUnit;
